import { PagerModel } from 'src/app/_models/system/pager-model';

export class SMSMessageReportsRetrievingModel {
  public FolderID: number;
  public PagerModel: PagerModel;

  constructor(init: any) {
    this.FolderID = init.FolderID;
    this.PagerModel = init.PagerModel;
  }
}
